import React, { FC } from 'react';
import { RoleList } from './list/RoleList';

export const RolesPage: FC = React.memo(function RolesPage() {
  return <RoleList />;
});
